export type BannerProps = {
  /**
   * Adds customizable content to the right side of the banner
   */
  BannerActions?: React.ReactNode;
  /** The icon in the header */
  Icon?: React.ReactNode;
  /** Inner components */
  children?: React.ReactNode;
  /** Whether the title provided in the title prop should be inline with the body. */
  isInlineTitle?: boolean;
  /**
   * whether or not to use the "subtle" version of a banner.
   * the "subtle" version has no background or padding of any kind
   */
  isSubtle?: boolean;
  /**
   * Function called when close button clicked.
   * If not provided, the close icon is hidden.
   */
  onClose?: (e: React.SyntheticEvent) => void;
  /** The title of the banner */
  title?: string;
  /**
   * The banner variant.  Determines the general styling.
   * NOTE: This will *not* determine the icon.
   */
  variant?: BannerVariants;
};

export enum BannerVariants {
  ERROR = 'error',
  INFO = 'info',
  NEUTRAL = 'neutral',
  SUCCESS = 'success',
  WARNING = 'warning',
}
